'use client';

import { envConfig } from '@env/config';
import { useEffect, useRef } from 'react';

export default function WalleyWidget({
  token,
  amount,
  locale,
}: {
  token: string;
  amount: number;
  locale: string;
}) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const script = ref.current.querySelector('script');
    if (!script) {
      return;
    }
    script.setAttribute('data-amount', String(amount * 100));
    window.walley?.checkout?.api?.update?.();
  }, [amount]);

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    if (!ref.current.querySelector('script')) {
      const script = document.createElement('script');
      script.setAttribute('src', envConfig.NEXT_PUBLIC_WALLEY_SCRIPT_SOURCE);
      script.setAttribute('data-token', token);
      script.setAttribute('data-widget', 'part-payment');
      script.setAttribute('data-amount', String(amount * 100));
      script.setAttribute('data-lang', locale);
      ref.current?.appendChild(script);
      return;
    }
    window.walley?.checkout?.api?.update?.();
  }, [token, locale, amount]);

  return <div ref={ref} className="mb-4 empty:mb-0" />;
}
